// Wallpaper roll calculator (product info block).
// The open/close row chrome is provided by the theme's <collapsible-row>
// accordion component; this module only handles the calculation and the
// add-to-cart, wired into this theme's cart drawer.

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wallpaper-calculator').forEach(initWallpaperCalculator);
});

const WP_STOCK_ERROR =
  'Not enough stock available to fulfil this request, please contact us for assistance.';

function initWallpaperCalculator(root) {
  if (root.dataset.wpInit) return;
  root.dataset.wpInit = 'true';

  const content = root.querySelector('.wallpaper-calculator__content');
  const output = root.querySelector('[data-wp-output]');
  const wasteLabel = root.querySelector('[data-wp-waste-label]');
  const errorBox = root.querySelector('[data-wp-error]');
  const errorText = root.querySelector('[data-wp-error-text]');
  const addBtn = root.querySelector('[data-wp-add]');
  const wallWidthInput = root.querySelector('[data-wp-input="wall-w"]');
  const wallHeightInput = root.querySelector('[data-wp-input="wall-h"]');
  const wasteInput = root.querySelector('[data-wp-input="waste"]');

  if (!content || !output || !addBtn) return;

  // Roll dimensions resolved in Liquid (metafield → block setting → default).
  const rollWidth = parseFloat(content.dataset.rollWidth) || 0.52;
  const rollLength = parseFloat(content.dataset.rollLength) || 10.05;
  const repeat = parseFloat(content.dataset.repeat) || 0;
  // Default waste %, used as the fixed value when the slider is hidden.
  const defaultWaste = parseFloat(content.dataset.waste) || 0;

  const stock = parseStock(root);

  // Recalculate on any input change.
  [wallWidthInput, wallHeightInput, wasteInput].forEach((el) => {
    if (!el) return;
    ['input', 'change'].forEach((evt) => el.addEventListener(evt, calculate));
  });

  addBtn.addEventListener('click', addToCart);

  calculate();

  // --- Core calculation -----------------------------------------------------
  function calculate() {
    hideError();
    enableAdd();

    const wallWidth = parseFloat(wallWidthInput && wallWidthInput.value) || 0;
    const wallHeight = parseFloat(wallHeightInput && wallHeightInput.value) || 0;
    // Use the slider when shown, otherwise the fixed default waste %.
    const waste = wasteInput ? parseFloat(wasteInput.value) || 0 : defaultWaste;

    if (wasteLabel) wasteLabel.textContent = waste;

    if (wallWidth <= 0 || wallHeight <= 0) {
      output.textContent = '-';
      return;
    }

    // Length of one drop, rounded up to the next full pattern repeat.
    let dropLength = wallHeight;
    if (repeat > 0) dropLength = Math.ceil(wallHeight / repeat) * repeat;

    const dropsPerRoll = Math.floor(rollLength / dropLength);
    if (dropsPerRoll < 1) {
      // A single drop is longer than the whole roll — not fulfillable.
      output.textContent = '!';
      disableAdd();
      return;
    }

    const totalDrops = Math.ceil(wallWidth / rollWidth);
    const rolls = Math.ceil((totalDrops / dropsPerRoll) * (1 + waste / 100));
    output.textContent = rolls;

    // Stock guard — only when the variant tracks inventory and denies oversell.
    const variant = stock[getVariantId()];
    if (
      variant &&
      variant.manage === 'shopify' &&
      variant.policy === 'deny' &&
      rolls > parseInt(variant.qty, 10)
    ) {
      showError(WP_STOCK_ERROR);
      disableAdd();
    }
  }

  // --- Add to cart (native cart-drawer integration) -------------------------
  function addToCart() {
    const rolls = parseInt(output.textContent, 10);
    const variantId = getVariantId();
    if (!rolls || rolls < 1 || !variantId) return;

    const originalLabel = addBtn.textContent;
    addBtn.textContent = 'Adding…';
    disableAdd();

    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', rolls);

    fetch(window.theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          showError(mapCartError(data));
          resetButton(originalLabel);
          return;
        }

        addBtn.textContent = '✓ Added to cart';

        // Refresh + open this theme's cart drawer.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', { product: data });
        }
        openCartDrawer();

        setTimeout(() => resetButton(originalLabel), 3000);
      })
      .catch(() => {
        showError('Sorry, something went wrong adding to your cart. Please try again.');
        resetButton(originalLabel);
      });
  }

  function mapCartError(data) {
    const msg = (data.description || data.message || '').toString();
    const lower = msg.toLowerCase();
    if (lower.includes('inventory') || lower.includes('already') || lower.includes('stock')) {
      return WP_STOCK_ERROR;
    }
    return msg || WP_STOCK_ERROR;
  }

  // --- Helpers --------------------------------------------------------------
  function getVariantId() {
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return urlVariant.toString();

    const formInput =
      document.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('[name="id"]');
    if (formInput && formInput.value) return formInput.value.toString();

    const keys = Object.keys(stock);
    return keys.length ? keys[0] : '';
  }

  function resetButton(label) {
    addBtn.textContent = label;
    enableAdd();
  }
  function showError(text) {
    if (!errorBox) return;
    if (errorText) errorText.textContent = text;
    errorBox.hidden = false;
  }
  function hideError() {
    if (errorBox) errorBox.hidden = true;
  }
  function disableAdd() {
    addBtn.disabled = true;
    addBtn.classList.add('is-disabled');
  }
  function enableAdd() {
    addBtn.disabled = false;
    addBtn.classList.remove('is-disabled');
  }
}

function parseStock(root) {
  const script = root.querySelector('.wallpaper-calculator__stock');
  if (!script) return {};
  try {
    return JSON.parse(script.textContent) || {};
  } catch (e) {
    return {};
  }
}

function openCartDrawer() {
  const drawerToggle = document.getElementById('cart-drawer-toggle');
  const drawer = document.getElementById('Cart-Drawer');
  // The toggle's own click handler opens the drawer via the theme's OverlayManager.
  if (drawer && drawerToggle) drawerToggle.click();
}
